import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';


import { IonicModule, ModalController } from '@ionic/angular';
import { PinchZoomComponent } from '@meddv/ngx-pinch-zoom';
import { environment } from '../../../environments/environment';
import { Image } from '../../../models/image.model';
import { Picture } from '../../../models/picture.interface.cs';

@Component({
    selector: 'app-fullscreen-image-modal',
    imports: [IonicModule, PinchZoomComponent],
    templateUrl: 'fullscreen-image-modal.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FullscreenImageModalComponent {
  /**
   * Either a disk-backed {@link Image} (post-volume-refactor) or a
   * legacy {@link Picture} carrying inline base64 (pre-refactor logs).
   * Resolved by `imageSrc` to the correct `<ion-img>` `[src]`.
   */
  public picture: Picture | Image;

  constructor(private modalCtrl: ModalController) {}

  public get imageSrc(): string {
    if (this.picture && this.picture.fileName) {
      return `${environment.fileUrl}/${this.picture.fileName}`;
    }
    const base64 = (this.picture as Picture)?.base64;
    return base64 ? `data:image/*;base64,${base64}` : '';
  }

  public async closeModal() {
    await this.modalCtrl.dismiss();
  }
}
